import * as React from 'react';
import {connect} from "react-redux";
import classnames from "classnames";
import PropTypes from "prop-types";
import {Col, Input, Row, Tooltip} from "reactstrap";

function CardContainer(props) {
	const {component, classes, error} = props

	return (
		<Col
			sm={12}
			className={classnames({
				'card-container': true,
				'error': error
			}) + " " + classes}
		>
			<div>
				{component}
			</div>
		</Col>
	);
}

CardContainer.propTypes = {
	classes: PropTypes.string,
	error: PropTypes.bool,
	component: PropTypes.any
};

function mapStateToProps(state) {
	return {}
}

export default connect(mapStateToProps, {})(CardContainer);